import { openDB, IDBPDatabase } from "idb";
import { AudiologyDB, ReportSettingsRecord } from "./index-db.types";

export const DB_SCHEMA_VERSION = 1;

async function initReportSettingsDB(): Promise<IDBPDatabase<AudiologyDB>> {
  return openDB<AudiologyDB>("ReportSettingsDB", DB_SCHEMA_VERSION, {
    upgrade(db) {
      const store = db.createObjectStore("reportSettings", {
        keyPath: "id",
      });

      store.createIndex("by_search", "search", { unique: true });
    },
  });
}

export async function upsertReportSetting(
  setting: Omit<Partial<ReportSettingsRecord>, "id"> & { id?: string }
): Promise<string> {
  const db = await initReportSettingsDB();
  const tx = db.transaction("reportSettings", "readwrite");
  const store = tx.objectStore("reportSettings");
  const index = store.index("by_search");

  const searchKey = `${setting.practiceId}-${setting.patientId}-${setting.reportId}`;

  const existing = await index.get(searchKey);

  if (existing) {
    const updatedRecord: ReportSettingsRecord = {
      ...existing,
      ...setting,
      search: searchKey,
    };
    await store.put(updatedRecord);
    return existing.id;
  } else {
    const newRecord = {
      ...setting,
      id: setting.id || crypto.randomUUID(),
      search: searchKey,
    } as ReportSettingsRecord;
    await store.add(newRecord);
    return newRecord.id;
  }
}

export async function getReportSettingById(
  id: string
): Promise<ReportSettingsRecord | undefined> {
  const db = await initReportSettingsDB();
  return db.get("reportSettings", id);
}

export async function findReportSetting(params: {
  practiceId: number;
  patientId: number;
  reportId: number;
}): Promise<ReportSettingsRecord | undefined> {
  const db = await initReportSettingsDB();
  const result = await db.getAllFromIndex(
    "reportSettings",
    "by_search",
    `${params.practiceId}-${params.patientId}-${params.reportId}`
  );

  return result?.at(0);
}

export async function deleteReportSetting(id: string) {
  const db = await initReportSettingsDB();
  return db.delete("reportSettings", id);
}
